<template>
  <svg width="13" height="10" viewBox="0 0 13 10" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M12.9663 5.8178C12.9056 5.67947 12.7721 5.59137 12.6251 5.59137H11.1251V0.386396C11.1251 0.173106 10.9571 0 10.7501 0L9.25006 0C9.04306 0 8.87506 0.173106 8.87506 0.386396V5.59137H7.37505C7.22805 5.59137 7.09455 5.68024 7.0338 5.8178C6.9723 5.95613 6.9963 6.11764 7.09305 6.23201L9.71807 9.32319C9.78932 9.40742 9.89207 9.45534 10.0001 9.45534C10.1081 9.45534 10.2108 9.40665 10.2821 9.32319L12.9071 6.23201C13.0046 6.11841 13.0271 5.95613 12.9663 5.8178Z"
        fill="currentColor"/>
    <path
        d="M0 0.5C0 0.223858 0.223858 0 0.5 0H5.5C5.77614 0 6 0.223858 6 0.5C6 0.776142 5.77614 1 5.5 1H0.5C0.223858 1 0 0.776142 0 0.5Z"
        fill="currentColor"/>
    <path
        d="M2 2.5C2 2.22386 2.22386 2 2.5 2H5.5C5.77614 2 6 2.22386 6 2.5C6 2.77614 5.77614 3 5.5 3H2.5C2.22386 3 2 2.77614 2 2.5Z"
        fill="currentColor"/>
    <path
        d="M4 4.5C4 4.22386 4.22386 4 4.5 4H5.5C5.77614 4 6 4.22386 6 4.5C6 4.77614 5.77614 5 5.5 5H4.5C4.22386 5 4 4.77614 4 4.5Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconSort"
}
</script>